import React, { FC } from 'react';
import i18n from 'i18n';

import { ModalProps } from '../types';
import Dialog from '../../Dialog/index';
import { AppType, minTileNumber } from '../../../../constants';

type TooFewTilesModalProps = ModalProps

export const TooFewTilesModal: FC<TooFewTilesModalProps> = ({ app, onCancel }) => {
  const title = app.type.toLocaleLowerCase() === AppType.TILE ?
    i18n('component.TooFewTilesModal.title')({ tileName: app.name }) :
    i18n('component.TooFewTilesModal.appTitle')({ tileName: app.name })

  const content = app.type.toLocaleLowerCase() === AppType.TILE ?
    i18n('component.TooFewTilesModal.content')({ tileName: app.name, minTileNumber }) :
    i18n('component.TooFewTilesModal.appContent')({ tileName: app.name, minTileNumber })

  return (
    <Dialog
      show={true}
      id="TooFewTilesModal"
      title={title}
      message={content}
      onDismiss={onCancel}
      actions={[
        {
          text: i18n('component.TooFewTilesModal.gotIt')(),
          onClick: onCancel,
          variant: 'filled',
          id: 'uninstall-button-cancel'
        }
      ]}
    />
  );
};
